import { namespaces } from '../../i18n.constants';

export const ptbr = {
  [namespaces.common]: {
    error: 'Erro',
    success: 'Sucesso',
    defaultError: 'Desculpe, houve um erro ao executar esta ação. Por favor tente novamente mais tarde.',
  },

  [namespaces.pages.home.home]: {

  },

  [namespaces.pages.service.serviceComponents.selectPropertyData.selectPropertyData]: {
    responsible_cooperative: 'Cooperado responsável',
    please_select_proprietary: 'Por favor, selecione o proprietário',
    select_property: 'Por favor, selecione uma propriedade',
    error_getting_subsidiaries: 'Desculpe, houve um erro ao buscar as filiais, por favor tente novamente mais tarde.',
  },

  [namespaces.error.sap]: {
    SAPTimeOut: 'Sem comunicação com o SAP - Alto tempo de espera ou servidor está inacessível.',
    SAPNotFound: 'Erro em ponto de comunicação - Endpoint BP não encontrado.',
    SAPBadRequest: 'Sem comunicação com o SAP - Requisição inválida.',
  },

  [namespaces.pages.deleteAccount.deleteAccount]: {
    different_user_id: 'Divergência de usuário a ser cancelado e usuário logado: não é permitido cancelar a conta de terceiros.',
    deleted_account: 'Sua conta foi excluída.',
    default_error_listmessages: 'Desculpe, houve um erro ao buscar as mensagens. Por favor tente novamente mais tarde.',
    user_notfound: 'Usuário não encontrado',
    delete_account_title: 'Excluir conta',
    continue_button_text: 'Continuar',
    delete_account_button_text: 'Solicitação de exclusão de conta',
    cancel_button_text: 'Cancelar',
  },
};
